// extracted by mini-css-extract-plugin
module.exports = {"container":"overlay_container__v_0zg","portal":"overlay_portal__3pynQ","contentHolder":"overlay_contentHolder__1PFPL"};